"use strict";

var _defineProperty = require("/codebuild/output/src372278538/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _breakpoints = _interopRequireDefault(require("../config/breakpoints"));
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var travelIcon = (0, _helpers.getImageByAgent)('travel_icon.svg');
var carIcon = (0, _helpers.getImageByAgent)('auto_icon.svg');
var homeIcon = (0, _helpers.getImageByAgent)('apartmentLink.svg');
var mortgageIcon = (0, _helpers.getImageByAgent)('mortgage_icon.svg');
var NotFoundHero = (0, _helpers.getImageByAgent)('404.svg');
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    bottomLink: {
      bottom: 'auto',
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(17.5),
      fontWeight: 700,
      letterSpacing: '0.7px',
      margin: '36px 0 72px',
      position: 'relative',
      textAlign: 'center',
      textDecoration: 'none',
      transition: 'all .15s ease-out'
    },
    hero: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      width: '100%'
    },
    img: {
      maxHeight: '100%',
      maxWidth: '100%',
      width: 'auto'
    },
    imgContainer: _defineProperty({
      height: 280,
      margin: 36,
      maxWidth: '100%',
      textAlign: 'center'
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      height: 140
    }),
    mainContent: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      width: '100%'
    },
    productIcon: {
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      height: 64,
      marginLeft: 24,
      marginRight: 6,
      maxWidth: 56,
      width: 72
    },
    productLabels: _defineProperty({
      flexGrow: 0,
      position: 'relative',
      transition: 'all .15s ease-out'
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      width: 'auto'
    }),
    productLink: _defineProperty({
      '&:hover, &:focus': {
        borderColor: theme.palette.primary.main
      },
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      border: 'solid 3px transparent',
      borderRadius: 999,
      boxShadow: '0 0 6px 0 rgba(0,0,0,0.22), 0 0 16px 0 rgba(0,0,0,0.16)',
      color: 'currentColor',
      display: 'flex',
      justifyContent: 'space-evenly',
      paddingRight: 20,
      position: 'relative',
      textAlign: 'initial',
      textDecoration: 'none',
      transition: 'all .5s ease-out'
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      boxShadow: '0 0 2px 0 rgba(0,0,0,0.08), 0 0 16px 0 rgba(7,41,56,0.08)',
      height: '100%',
      margin: '0 6px'
    }),
    productName: {
      color: theme.palette.secondary.darkLight,
      display: 'block',
      fontSize: theme.typography.pxToRem(14.875),
      fontWeight: 600,
      letterSpacing: '0.078rem',
      lineHeight: 1,
      transition: 'inherit'
    },
    products: {
      '@media screen and (max-width: 1270px)': {
        paddingBottom: 72
      },
      marginTop: 12,
      width: '100%'
    },
    productsList: _defineProperty({
      display: 'flex',
      flexDirection: 'row',
      height: '100%',
      justifyContent: 'center',
      listStyleType: 'none',
      margin: 0,
      padding: 0
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      flexDirection: 'column',
      justifyContent: 'flex-start'
    }),
    productsListItem: _defineProperty({
      '&:not(:last-of-type)': {
        marginBottom: 12,
        marginRight: 24
      },
      display: 'inline-block',
      flex: 'calc(50% - 2.4rem) 0 1',
      height: 84,
      maxWidth: 282
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      '&:not(:last-of-type)': {
        marginBottom: 32,
        marginRight: 0
      },
      flex: '64px 1 1',
      height: 64
    }),
    subheader: _defineProperty({
      fontSize: theme.typography.pxToRem(22.75),
      fontWeight: 300,
      textAlign: 'center'
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      fontSize: theme.typography.pxToRem(18.375)
    }),
    title: _defineProperty({
      color: theme.palette.secondary.main,
      fontSize: theme.typography.pxToRem(42),
      fontWeight: 300,
      lineHeight: 1,
      textAlign: 'center'
    }, "@media screen and (max-width: ".concat(_breakpoints.default.mobile, "px)"), {
      fontSize: theme.typography.pxToRem(30)
    })
  };
});
var NotFoundPage = function NotFoundPage() {
  var classes = useStyles();
  var isServiceSupported = function isServiceSupported(service) {
    return _helpers.agentDeveloperUtils.getSupportedServices.find(function (supportedService) {
      return supportedService === service;
    });
  };
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "column",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    direction: "column",
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.title,
    component: "h1"
  }, "\u05D4\u05D3\u05E3 \u05E9\u05D7\u05D9\u05E4\u05E9\u05EA \u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.imgContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: NotFoundHero,
    alt: "Page not found",
    className: classes.img
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.subheader
  }, "\u05E0\u05E9\u05DE\u05D7 \u05DC\u05E2\u05D6\u05D5\u05E8 \u05D1\u05E0\u05D5\u05E9\u05D0\u05D9\u05DD \u05D4\u05D1\u05D0\u05D9\u05DD"), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.products
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: classes.productsList
  }, isServiceSupported('auto') ? /*#__PURE__*/_react.default.createElement("li", {
    className: classes.productsListItem
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _helpers.agentDeveloperUtils.getSerivceWebsiteUrl('auto'),
    className: classes.productLink
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.productLabels
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.productName
  }, "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05E8\u05DB\u05D1")), /*#__PURE__*/_react.default.createElement("img", {
    src: carIcon,
    alt: "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05E8\u05DB\u05D1",
    className: classes.productIcon
  }))) : null, isServiceSupported('travel') ? /*#__PURE__*/_react.default.createElement("li", {
    className: classes.productsListItem
  }, /*#__PURE__*/_react.default.createElement("a", {
    // eslint-disable-next-line max-len
    href: _helpers.agentDeveloperUtils.getSerivceWebsiteUrl('travel'),
    className: classes.productLink
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.productLabels
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.productName
  }, "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05E0\u05E1\u05D9\u05E2\u05D5\u05EA \u05DC\u05D7\u05D5\u05F4\u05DC")), /*#__PURE__*/_react.default.createElement("img", {
    src: travelIcon,
    alt: "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05E0\u05E1\u05D9\u05E2\u05D5\u05EA \u05DC\u05D7\u05D5\u05F4\u05DC",
    className: classes.productIcon
  }))) : null, isServiceSupported('home') ? /*#__PURE__*/_react.default.createElement("li", {
    className: classes.productsListItem
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _helpers.agentDeveloperUtils.getSerivceWebsiteUrl('home'),
    className: classes.productLink
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.productLabels
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.productName
  }, "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05D3\u05D9\u05E8\u05D4")), /*#__PURE__*/_react.default.createElement("img", {
    src: homeIcon,
    alt: "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05D3\u05D9\u05E8\u05D4",
    className: classes.productIcon
  }))) : null, isServiceSupported('mortgage') ? /*#__PURE__*/_react.default.createElement("li", {
    className: classes.productsListItem
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: _helpers.agentDeveloperUtils.getSerivceWebsiteUrl('mortgage'),
    className: classes.productLink
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.productLabels
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.productName
  }, "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05DE\u05E9\u05DB\u05E0\u05EA\u05D0")), /*#__PURE__*/_react.default.createElement("img", {
    src: mortgageIcon,
    alt: "\u05D1\u05D9\u05D8\u05D5\u05D7 \u05DE\u05E9\u05DB\u05E0\u05EA\u05D0",
    className: classes.productIcon
  }))) : null))), /*#__PURE__*/_react.default.createElement("a", {
    href: _helpers.agentDeveloperUtils.getAgentLinks.website,
    className: classes.bottomLink
  }, "\u05D7\u05D6\u05E8\u05D4 \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D9\u05EA"));
};
var _default = exports.default = NotFoundPage;